/**
 * MC service
 */
'use strict';
angular.module('messageCenterServiceModule', [])
    .factory('messageCenterService', ["$q", "trsHttpService", function($q, trsHttpService) {
        return {
            /**
             * hasRead 判断是否已读
             * @param {string} noticeids 
             */
            hasRead: function(noticeids) {
                var defer = $q.defer();
                let params = {
                    serviceid: "notice",
                    method: "hasRead",
                    noticeids: noticeids
                }
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },
            /**
             * readNotices 设为已读 
             * @param {string} noticeids 
             */
            readNotices: function(noticeids, type) {
                var defer = $q.defer();
                let params = {
                    serviceid: "notice",
                    method: "readNotices",
                    noticeids: noticeids,
                    isall: type,
                }
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },
            /**
             * readNotices 设为已读 
             * @param {string} noticeids 
             */
            messageCenterReadNotices: function(msgsocketrelids, isall, socketid, type) {
                var defer = $q.defer();
                let params = {
                    serviceid: "message",
                    method: "readmessages",
                    msgsocketrelids: msgsocketrelids,
                    isall: isall,
                    socketid: socketid,
                    opertype: type,
                };
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "POST").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },

        }
    }]);